import { AxiosError } from "axios";

export function logAxiosError(axiosError: AxiosError): void {
  if (axiosError.response) {
    const { status, statusText, data } = axiosError.response;
    console.error({ status, statusText, data });
  } else if (axiosError.request) {
    console.error({
      title: "request failed",
      url: axiosError.request.url,
      axiosError,
    });
  } else {
    console.error(axiosError);
  }
}

export function axiosErrorToMessageKey(axiosError: AxiosError): string {
  // default error: something unexpected happened
  let errorMessageKey = "ui.modalUnexpectedError";
  if (!axiosError.response && axiosError.request) {
    // no response came back, it is possibly a network problem
    if (axiosError.code === "ECONNABORTED" || axiosError.code === "ETIMEDOUT") {
      // Uses ECONNABORTED for timeouts instead of ETIMEDOUT
      // https://github.com/axios/axios/issues/1543
      errorMessageKey = "ui.modalTimeoutError";
    } else if (axiosError.message === "Network Error") {
      errorMessageKey = "ui.modalError";
    }
  }
  return errorMessageKey;
}
